import { ColorPickerPopup } from "./color-picker";
import style from "./stroke-styler.module.css";
import { DropdownButton } from "../toolbar-buttons";
import { InputRangeWithMarks } from "./line-width-slider";
import { LineDash } from "./line-dash";
import { OutlineColor } from "frontend/ui-components/color-opacity-picker";

export function StrokeStyler({
  value,
  multi,
  onChangeColor,
  onChangeWidth,
  onChangeDash,
  colorPalette,
  tooltip = "Stroke",
  boundary = "no-controls-area",
  allowTransparency = true,
}: {
  value: {
    color?: string;
    dash?: number;
    width?: any;
  };
  multi: {
    color: boolean;
    dash: boolean;
    width: boolean;
  };
  onChangeColor: (newColor: string, addUndo: boolean) => void;
  onChangeWidth: (newWidth: number, addUndo: boolean) => void;
  onChangeDash: (newDash: number, addUndo: boolean) => void;
  colorPalette: string[];
  tooltip?: string;
  boundary?: string;
  allowTransparency?: boolean;
}) {
  function renderPopup(close: () => void) {
    return (
      <div>
        <div
          style={{
            display: "flex",
            marginBlockEnd: "8px",
            borderBottom: "1px solid #454545",
            alignItems: "center",
          }}
        >
          {/* line dash style */}
          <div style={{ padding: "8px" }}>
            <LineDash
              values={{ [value.dash || 0]: true }}
              onChange={function (value: number): void {
                onChangeDash(value, true);
              }}
            />
          </div>

          {/* vertical divider */}
          <div style={{ flex: "0 1px", alignSelf: "stretch", backgroundColor: "#454545" }} />

          {/* line width */}
          <div
            style={{
              flexGrow: 1,
              padding: "8px",
            }}
          >
            <InputRangeWithMarks
              min={1}
              max={10}
              step={1}
              value={value.width || 1}
              backgroundColor="#666666"
              onChange={(v) => onChangeWidth(v, false)}
              onFinish={(v) => onChangeWidth(v, true)}
            />
          </div>
        </div>

        {/* horizontal divider than ignores parent's padding*/}
        {/* <div style={{ height: "1px", width: "100%", backgroundColor: "#454545" }} /> */}

        {/* color & opacity  */}
        <div style={{ margin: "16px" }}>
          <ColorPickerPopup
            value={value.color ?? "#fff"}
            onChange={function (newValue: string, addUndo: boolean): void {
              onChangeColor(newValue, addUndo);
              // I don't close the popup on purpose, since opacity changes are long interaction
              // and base color changes are discrete. It might make sense to close on color change, but not on opacity change
            }}
            colorPalette={colorPalette}
            withTransparency={allowTransparency}
            closePopup={close}
          />
        </div>
      </div>
    );
  }

  const iconColor = multi.color
    ? "conic-gradient(#ff4800, #dfd902, #20dc68, #0092f4, #da54d8, #ff4800)"
    : value.color || "transparent";

  return (
    <DropdownButton
      tooltip={tooltip}
      renderPopup={renderPopup}
      data-testid={"stroke-styler"}
      className={style.popupMain}
      boundary={boundary}
    >
      <OutlineColor color={iconColor} />
      {/* {onlyOutline ? <OutlineColor color={iconColor} /> : <SolidColor color={iconColor} />} */}
    </DropdownButton>
  );
}
